import { User } from "./reducers";
import { Inspection, InspectionHistory, Checklist } from "../services/inspection.service";

export const actions = {
    login: (token: string, user: User): { type: string, payload: { token: string, user: User } } => ({
        type: 'LOGIN',
        payload: {
            token,
            user
        }
    }),
    logout: (): { type: string } => ({
        type: 'LOGOUT'
    }),
    
    // Inspection actions
    setCurrentInspection: (inspection: Inspection | null): { type: string, payload: Inspection | null } => ({
        type: 'SET_CURRENT_INSPECTION',
        payload: inspection
    }),
    
    setCompletedInspection: (inspection: Inspection | null): { type: string, payload: Inspection | null } => ({
        type: 'SET_COMPLETED_INSPECTION',
        payload: inspection
    }),
    
    setCurrentChecklists: (checklists: Checklist[]): { type: string, payload: Checklist[] } => ({
        type: 'SET_CURRENT_CHECKLISTS',
        payload: checklists
    }),
    
    setInspectionHistory: (history: InspectionHistory[]): { type: string, payload: InspectionHistory[] } => ({
        type: 'SET_INSPECTION_HISTORY',
        payload: history
    }),
    
    setHasCriticalEvent: (hasCritical: boolean): { type: string, payload: boolean } => ({
        type: 'SET_HAS_CRITICAL_EVENT',
        payload: hasCritical
    }),
    
    startPolling: (intervalId: number): { type: string, payload: number } => ({
        type: 'START_POLLING',
        payload: intervalId
    }),
    
    stopPolling: (): { type: string } => ({
        type: 'STOP_POLLING'
    }),
    
    updatePreviousInspection: (inspection: Inspection | null): { type: string, payload: Inspection | null } => ({
        type: 'UPDATE_PREVIOUS_INSPECTION',
        payload: inspection
    }),
    
    clearInspectionData: (): { type: string } => ({
        type: 'CLEAR_INSPECTION_DATA'
    }),
    
    setShowCriticalModal: (show: boolean): { type: string, payload: boolean } => ({
        type: 'SET_SHOW_CRITICAL_MODAL',
        payload: show
    }),

    modelOpen: (show: boolean): { type: string, payload: boolean } => ({
        type: 'MODAL_OPEN',
        payload: show
    }),

    // Notification actions
    setHasNewActivity: (hasNew: boolean): { type: string, payload: boolean } => ({
        type: 'SET_HAS_NEW_ACTIVITY',
        payload: hasNew
    }),

    clearActivityNotification: (): { type: string } => ({
        type: 'CLEAR_ACTIVITY_NOTIFICATION'
    }),

    setLastActivityCheck: (timestamp: string): { type: string, payload: string } => ({
        type: 'SET_LAST_ACTIVITY_CHECK',
        payload: timestamp
    })
};